export const LOVE_PHRASES = [
  // Frases inspiradas para celebrar con amigos
  "Celebremos juntos esta historia",
  "Vengan preparados, que esta fiesta va a estar más buena que asado de domingo",
  "La vida es corta y la fiesta larga, ¡no se la pierdan, culiau!",
  "Si nos quieren ver felices, traigan hielo y algo para escabiar",
  "Brindemos por los momentos que hemos vivido y los que vendrán",
  "Vengan nomás, que la joda sin ustedes es como el fernet sin coca",
  "Prepárense para una noche más larga que subida al Uritorco con resaca",
  "Con ustedes a nuestro lado, cada momento se vuelve inolvidable",
  "Esta fiesta va a estar más buena que siesta en día de calor",
  "Si el amor nos une, el escabio nos mantiene juntos toda la noche",
  "Como buen cordobés, prometemos que habrá más joda que laburo",
  "La amistad es como el cuarteto: te hace mover el corazón y los pies",
  "Momentos inolvidables, personas magicas",
  "Vengan a celebrar, que la vida es más corta que un sueldo a fin de mes",
  "Compartir nuestra alegría con ustedes la hace más grande",
  "Esta fiesta va a estar más movida que La Mona en el Sargento"
]; 